export interface IAttendee {
    id: number;
    userId: string;
    degree: string;
    degreeAfterName: string;
    firstName: string;
    lastName: string;
    dateOfBirth: Date | string;
    medicalNotes: string;
    pickUpPlace: string;
    insurance: string;
    street: string;
    city: string;
    postalCode: string;
    doprovod: string;
    phoneNumber: string;
    email: string;
    userName?: string;

}
export const emptyAttendee = (userId: string, street: string = "", city: string = "", postalCode: string = "",phoneNumber:string="",email:string="" ): IAttendee=> {
    const data: IAttendee = {
        city: city,
        degree: "",
        degreeAfterName:"",
        dateOfBirth: new Date(Date.now()),
        firstName: "",
        lastName: "",
        id: Math.floor((Math.random() * 10000) + 1)*-1,
        insurance: "",
        medicalNotes: "",
        pickUpPlace: "",
 
        postalCode: postalCode,
        street: street,
        userId: userId,
        doprovod: "",
        phoneNumber: phoneNumber,
        email: email,
        
    }

    return data;
}